import { NgModule } from '@angular/core';
import { HeaderbarComponent } from './headerbar/headerbar';
import { FooterbarComponent } from './footerbar/footerbar';
import { EzoomSvgComponent } from './ezoom-svg/ezoom-svg';
import { IonicModule, Keyboard } from 'ionic-angular';
import { HeadquartersProvider } from '../providers/headquarters'
import { PipesModule } from '../pipes/pipes.module';
import { MenuDirectiveModule } from '../directives/menu/menu.module';
import { PopoverTemplateComponent } from './mapa/popover-template/popover-template';
import { IMapaComponent } from './mapa/i-mapa/i-mapa';
import { AccordionComponent } from './accordion/accordion';
// Recaptcha
import { RECAPTCHA_SETTINGS, RecaptchaSettings, RecaptchaModule, RecaptchaComponent, RECAPTCHA_LANGUAGE, RecaptchaLoaderService } from 'ng-recaptcha';
import { C } from '../utils/constants';
import { TabsBarModule } from './tabs-bar/tabs-bar.module';
import { PopoverHorariosComponent } from './popover-horarios/popover-horarios';
import { DebugProvider } from '../providers/debug';
import { FieldsProvider } from '../providers/fields';
import { FileInputComponent } from './file-input/file-input';
import { InAppBrowser } from '@ionic-native/in-app-browser';

const captchaSettings: RecaptchaSettings = { siteKey: C.SITE_RC_KEY };
const captchaLanguage: string = 'pt-BR';

@NgModule({
    declarations: [
        HeaderbarComponent,
        FooterbarComponent,
        EzoomSvgComponent,
        PopoverHorariosComponent,
        FileInputComponent,
        AccordionComponent,
    ],
    imports: [
        MenuDirectiveModule,
        IonicModule,
        PipesModule,
        RecaptchaModule
    ],
    exports: [
        HeaderbarComponent,
        FooterbarComponent,
        EzoomSvgComponent,
        RecaptchaComponent,
        PopoverHorariosComponent,
        FileInputComponent,
        AccordionComponent,
    ],
    providers: [
        HeadquartersProvider,
        {
            provide: RECAPTCHA_SETTINGS, useValue: captchaSettings
        },
        {
            provide: RECAPTCHA_LANGUAGE, useValue: captchaLanguage
        },
        DebugProvider,
        RecaptchaLoaderService,
        FieldsProvider,
        InAppBrowser
    ],
    entryComponents: [
        PopoverHorariosComponent
    ]
})
export class CommonComponentsModule {}



// WEBPACK FOOTER //
// ./src/components/common-components.module.ts